import React from 'react'

import { DataItem } from 'scrivito'

import { DataItemDrawer } from '@/Atomic/Widgets/DataItemDrawer'
import { DocumentDrawer } from '@/Atomic/Widgets/DocumentDrawer'
import { DataClassName } from '@/Data/const'

interface DataItemDrawersProps {
  omitSidebar?: boolean
  drawerItem?: DataItem
  isOpen: boolean
  close: () => void
  startInEditMode?: boolean
  openDrawerId?: (id?: string) => void
  nextId?: string
  previousId?: string
}

export const DataItemDrawers: React.FC<DataItemDrawersProps> = ({
  omitSidebar,
  drawerItem,
  isOpen,
  close,
  startInEditMode,
  openDrawerId,
  nextId,
  previousId,
}) => {
  if (omitSidebar) {
    return null
  }

  if (!drawerItem) {
    return null
  }

  const dataClassName = drawerItem?.dataClassName()

  if (dataClassName === DataClassName.DOCUMENT) {
    return (
      <DocumentDrawer
        document={drawerItem}
        isOpen={isOpen}
        close={close}
        startInEditMode={startInEditMode}
        openDrawerId={openDrawerId}
        nextId={nextId}
        previousId={previousId}
      />
    )
  }

  return (
    <DataItemDrawer
      key={drawerItem.id()}
      dataItem={drawerItem}
      isOpen={isOpen}
      close={close}
      startInEditMode={startInEditMode}
      openDrawerId={openDrawerId}
      nextId={nextId}
      previousId={previousId}
    />
  )
}
